import { AxiosResponse } from 'axios'

import { PrimaryWorkPattern } from 'types/primaryWorkPattern'
import { SecuritiesSecurityField } from 'types/securitiesSecurityFields'

import { _axios } from './axios'

const FILTER_BY_SECURITY_FIELD = (securityFieldId: string) =>
  `/securities_security_fields/${securityFieldId}`
const CREATE = '/securities_security_fields'
const UPDATE = (id: string) => `/securities_security_fields/${id}`
const BULK_UPDATE = '/securities_security_fields/bulk_update'
const BULK_DELETE = (securityFieldId: string) =>
  `/securities_security_fields/bulk_delete/${securityFieldId}`

export const securitiesSecurityFieldApi = () => {
  const filterBySecurityField = async (
    securityFieldId: string,
  ): Promise<
    AxiosResponse<{
      relations: (SecuritiesSecurityField & {
        primaryWorks: PrimaryWorkPattern[]
      })[]
    }>
  > => {
    return await _axios().get(FILTER_BY_SECURITY_FIELD(securityFieldId))
  }

  const create = async (data: {
    securityFieldId: string
    securityId: string
    primaryWorkIds: string[]
  }): Promise<AxiosResponse<void>> => {
    return await _axios().post(CREATE, data)
  }

  const update = async (
    id: string,
    data: {
      primaryWorkIds: string[]
    },
  ): Promise<AxiosResponse<void>> => {
    return await _axios().put(UPDATE(id), data)
  }

  const bulkUpdate = async (data: {
    relations: SecuritiesSecurityField[]
  }): Promise<AxiosResponse<void>> => {
    return await _axios().put(BULK_UPDATE, data)
  }

  const bulkDelete = async (
    securityFieldId: string,
    data: {
      ids: string[]
    },
  ): Promise<AxiosResponse<void>> => {
    return await _axios().delete(BULK_DELETE(securityFieldId), {
      data,
    })
  }

  return {
    filterBySecurityField,
    create,
    update,
    bulkUpdate,
    bulkDelete,
  }
}
